import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Tooltip,
} from "@material-ui/core";
import React, { ReactElement } from "react";
import { useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./korrelationStyle";
import { selectHeaderList, selectKorrelationList } from "./korrelationSlice";
import ColorValues from "./colorTableCell";
import { CorrelationCalculationType, korrelationResult } from "./korrelationTypes";
import { selectErgebnistyp, selectselectedCalculatedKorrelation } from "./korrelationFilterSlice";
import LegendeKorrelation from "./legendeKorrelation";


import { selectKennegroesse } from "../../../features/filter/kenngroesseSlice";

export default function KorrelationTable(): ReactElement {
  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };

  const selectedKorrelation = useAppSelector(selectselectedCalculatedKorrelation);
  const ergebnistyp = useAppSelector(selectErgebnistyp);

  const korrelationResultList = useAppSelector(selectKorrelationList);
  const headerList = useAppSelector(selectHeaderList);


  const kenngroesseListWithDetails = useAppSelector(selectKennegroesse);

  function createTableCell(kwElem: string, rows: korrelationResult[]) {
    const rowsMaxIndex = rows.length;
    let rowsIndex = 0;
    const cellValue = 11;
    while (rowsMaxIndex > rowsIndex) {
      // eslint-disable-next-line security/detect-object-injection
      if (kwElem == rows[rowsIndex].col) {
        return (
          <ColorValues
            // eslint-disable-next-line security/detect-object-injection
            value={rows[rowsIndex].value}
            maxValue={
              selectedKorrelation.korrelationstyp == CorrelationCalculationType.betweenKenngroessen? selectedKorrelation.messstellen.length : selectedKorrelation.kenngroessen.length
            }
          />
        );
      }
      rowsIndex += 1;
    }
    return <ColorValues value={cellValue} maxValue={0} />;
  }

  return (
    <React.Fragment>
      <Grid item md={12} style={{ textAlign: "left", marginRight: "20px" }}>
        <div>
          <LegendeKorrelation
            resultType={ergebnistyp}
            max={selectedKorrelation.korrelationstyp == CorrelationCalculationType.betweenKenngroessen ? selectedKorrelation.messstellen.length : selectedKorrelation.kenngroessen.length}
            min={0}
          />
          <TableContainer component={Paper} style={{ height: "80vh" }}>
            <Table aria-label='simple table' className={classes.table}>
              <TableHead>
                <TableCell className={classes.tableHeaderHorizontalLeftmost}>
                  {selectedKorrelation.korrelationstyp == CorrelationCalculationType.betweenMessstellen
                    ? "Messstelle"
                    : "Kenngröße"}{" "}
                </TableCell>
                {headerList.map((elem, index) => {
                  const description = kenngroesseListWithDetails.find(
                    (el) => el.kurzname == elem
                  )?.beschreibung;

                  return <Tooltip
                    title={
                      description && description != undefined
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        ? description!
                        : ""
                    }
                    key={index}
                  >
                    <TableCell
                      className={classes.tableHeaderHorizontal}
                      key={index}
                    >
                      {elem}
                    </TableCell>
                  </Tooltip>;
                })}
              </TableHead>
              <TableBody>
                {korrelationResultList.map((rows, index) => {
                  const description = kenngroesseListWithDetails.find(
                    (el) => el.kurzname == rows[0].row
                  )?.beschreibung;
                  return <TableRow key={rows[0].row}>    
                      <Tooltip
                        title={
                          description && description != undefined
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            ? description!
                            : ""
                        }
                        key={index}
                      >
                        <TableCell className={classes.tableHeaderVertical}>
                      {rows[0].row}
                    </TableCell>
                    </Tooltip>
                    {headerList.map((kwElem) => createTableCell(kwElem, rows))}
                  </TableRow>
                })}
                <TableRow>
                  <TableCell className={classes.emptyTableCell} />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Grid>
    </React.Fragment>
  );
}
